<template>
  <div id="optimiseurContainer">
    <div class="title mt-5">
      {{ title }}
    </div>
    <div class="subtitle mt-5">{{ subtitle }}</div>
  </div>
</template>
<script>
export default {
  props: ["title", "subtitle"],
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
#optimiseurContainer {
  .title {
    text-align: center;
    font: normal normal normal $mf_ft_size_big_title Dosis;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
  }
  .subtitle {
    text-align: center;
    font: normal normal normal $mf_ft_size_big_subtitle Segoe UI;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
  }
}
</style>
